import { httpClient, ApiResponse, convertModelToFormData } from '@/utils';
import {
  BannerEndpoints,
  IBannerListResponse,
  ICreateBannerDTO,
  ICreateBannerResponse,
  IGetBannersListDTO,
  IReorderBannersDTO,
} from '@/models/banners.model';

class BannersAPI {
  static getBannersList(data: IGetBannersListDTO): ApiResponse<IBannerListResponse> {
    return httpClient.get<IBannerListResponse>(BannerEndpoints.BANNERS, { params: data });
  }

  static reorderBanners(data: IReorderBannersDTO): ApiResponse<IBannerListResponse> {
    return httpClient.put<IBannerListResponse>(`${BannerEndpoints.BANNERS}/reorder`, data);
  }

  static getBanner(id: string): ApiResponse<ICreateBannerResponse> {
    return httpClient.get<ICreateBannerResponse>(`${BannerEndpoints.BANNERS}/${id}`);
  }

  static deleteBanner(id: string) {
    return httpClient.delete(`${BannerEndpoints.BANNERS}/${id}`);
  }

  static createBanner(data: ICreateBannerDTO): ApiResponse<ICreateBannerResponse> {
    const formData = convertModelToFormData(data);
    return httpClient.post<ICreateBannerResponse>(`${BannerEndpoints.BANNERS}`, formData);
  }

  static editBanner(id: string, data: Partial<ICreateBannerDTO>): ApiResponse<ICreateBannerResponse> {
    const formData = convertModelToFormData(data);
    return httpClient.post<ICreateBannerResponse>(`${BannerEndpoints.BANNERS}/${id}`, formData);
  }
}

export default BannersAPI;
